module.exports = __webpack_public_path__ + "static/media/ma.892db39b.svg";